import { listeCarteImageTitreLienMock, titreDescriptionMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionMock(), listeCarteImageTitreLienMock];

export const lpConfigurateurMock: SlugPage = {
  ...pageBase({
    title: 'LP Configurateur',
    type: 'page',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
